import React from 'react'
import PropTypes from 'prop-types'
import './_time-selector.scss'
import { getFriendlyTimezoneName } from '../../utils'

const TimeSelector = ({ options, title, name, onChange, selectedTimeSlot, timezone }) => {
  return (
    <div className="time-selector">
      {title && options?.length > 0 && <h3 className="time-selector__title">{title} {getFriendlyTimezoneName(timezone)}</h3>}
      <div className="time-selector__options">
        {options?.map(({ label, value }) => (
          <label className= { value.availableSlots <= 0 ? "time-selector__options time-selector__options--disabled" : "time-selector__options" } key={value.startTimeInUTC}>
            <input 
              data-testid="time" 
              type="radio" 
              className="time-selector__radio" 
              name={name || 'time-selector'} 
              disabled={ value.availableSlots <= 0 } 
              value={value.appointmentWindowId} 
              onChange={onChange.bind(null, value)} 
              checked={value.availableSlots > 0 && selectedTimeSlot?.appointmentWindowId === value.appointmentWindowId}
              />
            <div className="time-selector__inner">
              <span className="time-selector__faux-radio" />
              <span className="time-selector__label">{label}</span>
            </div>
          </label>
        ))}
      </div>
    </div>
  )
}

TimeSelector.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.shape({
      appointmentWindowId: PropTypes.string.isRequired
    }).isRequired,
  })),
  onChange: PropTypes.func,
}

export default TimeSelector